import React from 'react';
import LandingPage from './LandingPage';

function App() {
  return (
    <div className="w-full min-h-screen">
      <LandingPage />
    </div>
  );
}

export default App;
